import react, {useEffect, useState} from 'react'
import commonStyles from "../commonStyles";
import Name from "../Images/Name_light.png"
import YourCharge from "../Images/YourCharge_light.png"
import MoneyGiven from "../Images/MoneyGiven_light.png"
import GuidaOverlay from "./GuidaOverlay";
import React from "react";

function createCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name,"",-1);
}

function FormPersona(props) {

    useEffect(() => {
        console.log(props.flag)
        if(props.flag) {
            if(readCookie("firstVisitFormTrue") == null) {
                props.toggleOverlay(!props.showOverlay)
                createCookie("firstVisitFormTrue", false, 30)
            } else {
                createCookie("firstVisitFormTrue", false, 30)
            }
        } else {
            if(readCookie("firstVisitFormFalse") == null) {
                props.toggleOverlay(!props.showOverlay)
                createCookie("firstVisitFormFalse", false, 30)
            } else {
                createCookie("firstVisitFormTrue", false, 30)
            }
        }

    }, [])

    return(
        <>
            {props.flag?
                <GuidaOverlay
                    isShown = {props.showOverlay}
                    images = {[{img: Name, id: 0}, {img: YourCharge, id: 1}, {img: MoneyGiven, id: 2}]}
                    toggleOverlay = { props.toggleOverlay }
                />
                :
                <GuidaOverlay
                    isShown = {props.showOverlay}
                    images = {[{img: Name, id: 0}, {img: MoneyGiven, id: 2}]}
                    toggleOverlay = { props.toggleOverlay }
                />
            }

            <div className="center">

                <div className="card text-center shadow-lg p-3 mt-5 bg-body rounded" style={ (props.flag)? commonStyles.forum : commonStyles.forum1}>
                    <div className="card-body px-4">

                        <h2 className="card-title" style={commonStyles.cardTitle}>Add Friend</h2>

                        <form name="modulo">
                            <div className="form-floating mb-3">
                                <input type="name" className={"form-control" + props.errorNome} id="floatingInput" placeholder="Luca" name="nome"/>
                                <label htmlFor="floatingInput">Name</label>
                                <span></span>
                            </div>

                            {props.flag && <div className="form-floating mb-3">
                                <input type="number" className={"form-control" + props.errorSpesaPers} id="floatingInput" placeholder="10" name="spesaPers"/>
                                <label htmlFor="floatingInput">Your Charge</label>
                            </div>
                            }

                            <div className="form-floating mb-3">
                                <input type="number" className={"form-control" + props.errorSpesaTot} id="floatingInput" placeholder="Luca" name="spesaTot"/>
                                <label htmlFor="floatingInput">Money Given</label>
                            </div>
                        </form>

                        <div className={"bottoni-dist"}>
                            <button className="coolbtn add me-2" style={ commonStyles.btnForm } onClick={ () => { props.onBack() } }>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-box-arrow-left" viewBox="0 2 16 16">
                                    <path fillRule="evenodd"
                                          d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"/>
                                    <path fillRule="evenodd"
                                          d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"/>
                                </svg>
                            </button>
                            <button className="coolbtn ms-2" style={ commonStyles.btnForm } onClick={ () => {

                                props.onAggPersone(props.flag)
                            } }>ADD</button>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default FormPersona